import { render } from "./ConfCancelPage.vue?vue&type=template&id=597ea2f2"
import script from "./ConfCancelPage.vue?vue&type=script&lang=js"
export * from "./ConfCancelPage.vue?vue&type=script&lang=js"

import exportComponent from "D:\\workspace\\eduwind-front\\eduwind-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__